<template>
    <tr>
        <td> {{this.rigaIntervento.CodiceIntervento}} </td>
        <td> {{this.rigaIntervento.DescrizioneAttivita}} </td>
        <td>{{ this.rigaIntervento.NoteIntervento }} </td>
        <td>{{ this.rigaIntervento.DescrizioneEsito }} </td>
        <td> {{this.formatDateNoOre(this.rigaIntervento.DataGestione)}} </td>
        <td> {{this.rigaIntervento.TipoIntervento}}</td>
    </tr> 
</template>

<script>
import {dateMixin,StatoInterventoEntitaMixin} from "/mixin.js";

export default {
    name: "RigaGrigliaStoricoInterventi",
    mixins:[dateMixin,StatoInterventoEntitaMixin],
    props :{
        rigaIntervento: Object
    },
    mounted: function(){
        this.rigaIntervento.CodiceIntervento = this.rigaIntervento.SysChiaveglobale.split('~|~')[1];
    }
}
</script>